import { render, staticRenderFns } from "./PurchaseViewItem.vue?vue&type=template&id=20199403&scoped=true&"
import script from "./PurchaseViewItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseViewItem.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseViewItem.vue?vue&type=style&index=0&id=20199403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20199403",
  null
  
)

export default component.exports